import React from 'react';
import { Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CardActionArea from '@material-ui/core/CardActionArea';
import ArrowForward from '@material-ui/icons/ArrowForward';
import MetricTile from '~/app/Components/Dashboard/OverviewV2/primitives/MetricTile';

const styles = theme => ({
  wrapper: { ...theme.statCard.wrapper },
  statCardOverview: { ...theme.statCard.statCardOverview },
  statCard: { ...theme.statCard.statCard },
  small: { ...theme.statCard.statCardSmall },
  large: { ...theme.statCard.statCardLarge },
  content: { ...theme.statCard.content },
  actionArea: { ...theme.statCard.actionArea },
  focusVisible: { ...theme.statCard.focusVisible },
  actionCue: { ...theme.statCard.actionCue },
  arrow: { ...theme.statCard.arrow },
});

const StatCard = ({ classes, variant, onClick, card }) => {
  const cardClass = variant
    ? classes.statCardOverview
    : card.title === 'Transmitter Add On'
    ? classes.large
    : ['Refused', 'Queued'].includes(card.title)
    ? classes.small
    : classes.statCard;
  const content = <MetricTile variant={variant} card={card} />;
  let metricLabel = card.count;
  if (card.loading) {
    metricLabel = 'Loading';
  } else if (card.error) {
    metricLabel = `Error loading ${card.title}`;
  }

  return (
    <div className={classes.wrapper}>
      <Paper elevation={2} className={cardClass}>
        {onClick ? (
          <CardActionArea
            onClick={onClick}
            className={`${classes.content} ${classes.actionArea}`}
            classes={{ focusVisible: classes.focusVisible }}
            aria-label={`${card.title}: ${metricLabel}; view returns`}
          >
            {content}
            <span className={classes.actionCue}>
              View returns <ArrowForward className={classes.arrow} aria-hidden="true" />
            </span>
          </CardActionArea>
        ) : (
          <div className={classes.content}>{content}</div>
        )}
      </Paper>
    </div>
  );
};

export default withStyles(styles)(StatCard);
